/**
 * Thrown from a request interceptor's retry-pin check when a pinned retry
 * must not dispatch — the auth-recovery context it was pinned to is stale,
 * or unavailable outright. A plain `Error` re-entering response handling
 * this way carries no `.response`/`.config`, so it falls through generic
 * classification and surfaces as an opaque failure. This sentinel lets every
 * response-handler implementation recognise the case explicitly and reject
 * it directly — no retry, no logout, no legacy processing.
 */
export class AuthRetryRevisionStaleError extends Error {
  constructor() {
    super('AUTH_RETRY_REVISION_STALE');
    this.name = 'AuthRetryRevisionStaleError';
  }
}

export function isAuthRetryRevisionStaleError(
  error: unknown
): error is AuthRetryRevisionStaleError {
  return error instanceof AuthRetryRevisionStaleError;
}
